import { Fragment, useEffect, useState } from 'react'
import { Menu, Transition } from '@headlessui/react'
import { UserCircleIcon } from '@heroicons/react/24/outline'
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import ProfilePage from '../ProfileDetail/ProfilePage'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Profile({ isSuperAdmin = false, setCurrentComponent = null }) {
  const [userName, setUserName] = useState('');

  useEffect(() => {
    const updateUserName = () => {
      try {
        if (isSuperAdmin) {
          // For superadmin dashboard
          const superadminData = localStorage.getItem('superadminUser');
          if (superadminData) {
            const user = JSON.parse(superadminData);
            setUserName(user.name || user.email || 'Super Admin');
          }
        } else {
          // For regular admin dashboard
          const token = localStorage.getItem('token');
          if (token) {
            // Fetch user profile from API
            fetch('https://didrouteapi.com/api/users/profile', {
              headers: {
                'Authorization': `Bearer ${token}`
              }
            })
            .then(response => response.json())
            .then(data => {
              if (data.name) {
                setUserName(data.name);
                // Store user data in localStorage
                localStorage.setItem('userData', JSON.stringify(data));
              }
            })
            .catch(error => {
              console.error('Error fetching user profile:', error);
              setUserName('User');
            });
          }
        }
      } catch (error) {
        console.error('Error updating user name:', error);
        setUserName(isSuperAdmin ? 'Super Admin' : 'User');
      }
    };

    updateUserName();
  }, [isSuperAdmin]);

  const handleLogout = () => {
    if (isSuperAdmin) {
      localStorage.removeItem('superadminToken');
      localStorage.removeItem('superadminUser');
      window.location.href = '/superadmin/login';
    } else {
      localStorage.removeItem('token');
      localStorage.removeItem('userData');
      window.location.href = '/login';
    }
  };

  const handleProfile = () => {
    if (setCurrentComponent && !isSuperAdmin) {
      setCurrentComponent(<ProfilePage />);
    }
  };

  return (
    <Menu as="div" className="relative">
      <Menu.Button className="-m-1.5 flex items-center p-1.5">
        <span className="sr-only">Open user menu</span>
        <img
          alt=""
          src="https://img.freepik.com/premium-vector/man-profile-cartoon_18591-58482.jpg?w=360"
          className="size-8 rounded-full bg-gray-50"
        />
        <span className="hidden lg:flex lg:items-center">
          <span
            className="ml-4 text-sm/6 font-semibold leading-6 text-gray-900"
            aria-hidden="true"
          >
            {userName || "Loading..."}
          </span>
          <ChevronDownIcon
            aria-hidden="true"
            className="ml-2 size-5 text-gray-400"
          />
        </span>
      </Menu.Button>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 z-10 mt-2.5 w-32 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none">
          {!isSuperAdmin && (
            <Menu.Item>
              {({ active }) => (
                <button
                  onClick={handleProfile}
                  className={classNames(
                    active ? "bg-gray-50" : "",
                    "block px-3 py-1 text-sm leading-6 text-gray-900 w-full text-left"
                  )}
                >
                  Profile
                </button>
              )}
            </Menu.Item>
          )}
          <Menu.Item>
            {({ active }) => (
              <button
                onClick={handleLogout}
                className={classNames(
                  active ? "bg-gray-50" : "",
                  "block px-3 py-1 text-sm leading-6 text-gray-900 w-full text-left"
                )}
              >
                Sign out
              </button>
            )}
          </Menu.Item>
        </Menu.Items>
      </Transition>
    </Menu>
  );
}